<app-page-header-job [isCurveGray]="true" header="{{language.jobheader}}" backgroundPath="assets/images/lead/bg.jpg">
</app-page-header-job>

<section class="section--feature">
  <div class="container">
    <div class="row radio--menu">
      <div class="col-3 col-sm-3 col-md-3 col-lg-3 col-xl-3">
        <app-big-radio [active]="Personal" icon="assets/images/icon/user-job.png" title="{{language.jobtitleicon1}}">
        </app-big-radio>
      </div>
      <div class="col-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 port-plan">
        <app-big-radio [active]="Education" icon="assets/images/icon/mortarboard-job.png"
          title="{{language.jobtitleicon2}}"></app-big-radio>
      </div>
      <div class="col-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 port-plan">
        <app-big-radio [active]="Family" icon="assets/images/icon/family-room-job.png"
          title="{{language.jobtitleicon3}}"></app-big-radio>
      </div>
      <div class="col-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 port-plan">
        <app-big-radio [active]="Experience" icon="assets/images/icon/suitcase-job.png"
          title="{{language.jobtitleicon4}}"></app-big-radio>
      </div>
    </div>
  </div>
</section>

<div ng-app="MyApp" ng-controller="MyController">

  <!-- ข้อมูลครอบครัว -->
  <div class="container">
    <div class="row">
      <div class="col-lg-12 col-md-12 col-sm-12 text-center card p-5 mt-5 mb-5">

        <header class="heading-contact mb-5">
          <h2 class="topic-title">{{language.jobapplydetail16}}</h2>
        </header>

        <div class="row">
          <div class="col-lg-3 col-md-3 col-sm-3 mb-3">
            <div class="form--item">
              <div class="title d-flex">{{language.jobfamstatus1}}<p class="req pl-3">*</p>
              </div>
              <div class="input">
                <div class="input--container">
                  <div class="form-group">
                    <div class="dropdown">
                      <button aria-expanded="false" aria-haspopup="true" class="select--button" data-toggle="dropdown"
                        id="dropdownMenu2" type="button" role="button" [ngClass]="{ 'is-invalid': ReqMaritalStatus }">
                        <span>{{ MaritalStatus || defaultTitle }}</span>
                        <span>
                          <img src="assets/images/icon/caret-down@2x.png" alt="arrow-dropdown" />
                        </span>
                      </button>
                      <div aria-labelledby="dropdownMenu2" class="dropdown-menu" x-placement="bottom-start">
                        <ul aria-expanded="false" class="menu--list" role="listbox"
                          style="max-height: 450px; overflow-y: auto;">
                          <li *ngFor="let items of MaritalSelect" class="dropdown-item" style="height: 50px;" (change)="changeTitle($event.items)"
                            (click)="onclickMarital(items)">
                            <a aria-disabled="false" aria-selected="false" class="" data-tokens="null" role="option"
                              ta-tokens="null" tabindex="0" data-value="items">
                              <span class="text">{{items}}</span>
                              <span class="glyphicon glyphicon-ok check-mark"></span>
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div *ngIf="ReqMaritalStatus" class="error-message">
                      {{language.joberror1}}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- ปีสมรส -->
          <div class="col-lg-3 col-md-3 col-sm-3 mb-3" *ngIf="MaritalStatus == 'Married' || MaritalStatus == 'สมรส'">
            <div class="form--item">
              <div class="title d-flex">{{language.jobapplydetail37}}<p class="req pl-3">*</p>
              </div>
              <div class="input">
                <div class="input--container">
                  <input type="text" (input)="married_year=$event.target.value" id="marriedYear" class="form-control"
                    [ngClass]="{ 'is-invalid': ReqMarriedYear }" maxlength="4" [pattern]="mobnumPattern" numbersOnly />
                </div>
                <div *ngIf="Reqage1" class="error-message">
                  {{language.joberror1}}
                </div>
              </div>
            </div>
          </div>


          <!-- จำนวนบุตร -->
          <div class="col-lg-3 col-md-3 col-sm-3 mb-3" *ngIf="MaritalStatus != 'Single' && MaritalStatus != 'โสด'">
            <div class="form--item">
              <div class="title d-flex">{{language.jobapplydetail17}}<p class="req pl-3">*</p>
              </div>
              <div class="input">
                <div class="input--container">
                  <div class="form-group">
                    <div class="dropdown">
                      <button aria-expanded="false" aria-haspopup="true"
                        class="select--button {{isLight ? 'light': ''}} {{isRequire? 'require': ''}}"
                        data-toggle="dropdown" id="dropdownMenu2" type="button" role="button"
                        [ngClass]="{ 'is-invalid': ReqNumberChildren }">
                        <span>{{ NumberChildren || defaultTitle }}</span>
                        <span>
                          <img src="assets/images/icon/caret-down@2x.png" alt="arrow-dropdown" />
                        </span>
                      </button>
                      <div aria-labelledby="dropdownMenu2" class="dropdown-menu" x-placement="bottom-start">
                        <ul aria-expanded="false" class="menu--list" role="listbox"
                          style="max-height: 450px; overflow-y: auto;" >
                          <li *ngFor="let items of NumberChild" class="dropdown-item" style="height: 50px;" (change)="onclickNumberChildren($event.items)"
                            (click)="onclickNumberChildren(items)">
                            <a aria-disabled="false" aria-selected="false" class="" data-tokens="null" role="option"
                              ta-tokens="null" tabindex="0" data-value="items">
                              <span class="text">{{items}}</span>
                              <span class="glyphicon glyphicon-ok check-mark"></span>
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div *ngIf="ReqNumberChildren" class="error-message">
                    {{language.joberror1}}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- บุตร -->
        <header class="heading-contact mb-5 mt-5" *ngIf="NumberChildren > 0">
          <h2 class="topic-title">{{language.jobapplydetail55}}</h2>
          <p class="ingnor-top">* {{language.jobeduwarning2}} -</p>
        </header>
        <form [formGroup]="formDataChild">
          <div  formArrayName="ChildInfo" *ngFor="let DataChild of formDataChild.get('ChildInfo')['controls']; let i = index">
            <ng-container [formGroupName]="i">

              <div class="row">
                <div class="col-lg-12 col-md-12 col-sm-12 mb-3 mt-5" *ngIf="i >=1">
                  <div class="title-group">{{language.jobnumber}} {{i+1}}</div>
                </div>

                <!-- <div class="col-lg-6 col-md-6 col-sm-6 mb-3 mt-5" *ngIf="i >=1">
                  <app-button-delete-job text="{{language.btn6}}" (click)="removeChild(i)">
                    <button class="button--primary">
                      <span>
                        <a routerLink="">{{language.jobbtn2}}</a>
                      </span>
                    </button>
                  </app-button-delete-job>
                </div> -->

                <div class="col-lg-3 col-md-3 col-sm-12 mb-3">
                  <div class="form--item">
                    <div class="title">{{language.jobfamtitle1}}</div>
                    <div class="form-group">
                      <div class="dropdown">
                        <select formControlName="c_title" class="form-control" [ngClass]="{ 'is-invalid': Reqc_title }">
                          <option *ngFor="let items of ChildTitleTH" [value]="items" style=" border-radius: 50px;">
                            {{ items }}</option>
                        </select>
                      </div>
                      <div *ngIf="Reqc_title" class="error-message">
                        {{language.joberror1}}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-12 mb-3">
                  <div class="form--item">
                    <div class="title">{{language.jobfamtitle10}}</div>
                    <div class="input">
                      <div class="input--container">
                        <input type="text" formControlName="c_fname" class="form-control"
                          [ngClass]="{ 'is-invalid': Reqc_fname }">
                      </div>
                      <div *ngIf="Reqc_fname" class="error-message">
                        {{language.joberror1}}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-5 col-md-5 col-sm-12 mb-3">
                  <div class="form--item">
                    <div class="title">{{language.jobfamtitle11}}</div>
                    <div class="input">
                      <div class="input--container">
                        <input type="text" formControlName="c_lname" class="form-control"
                          [ngClass]="{ 'is-invalid': Reqc_lname }">
                      </div>
                      <div *ngIf="Reqc_lname" class="error-message">
                        {{language.joberror1}}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-lg-3 col-md-3 col-sm-12 mb-3">
                  <div class="form--item">
                    <div class="title">{{language.jobfamtitle4}}</div>
                    <div class="input">
                      <div class="input--container">
                        <input type="text" formControlName="c_age" class="form-control"
                          [ngClass]="{ 'is-invalid': Reqc_age }" maxlength="2" numbersOnly>
                      </div>
                      <div *ngIf="Reqc_age" class="error-message">
                        {{language.joberror1}}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-12 mb-3">
                  <div class="form--item">
                    <div class="title">{{language.jobfamtitle5}}</div>
                    <div class="input">
                      <div class="input--container">
                        <input type="text" formControlName="c_tel" class="form-control"
                          [ngClass]="{ 'is-invalid': Reqc_tel }" numbersOnly [maxLength]="10">
                      </div>
                      <div *ngIf="Reqc_tel" class="error-message">
                        {{language.joberror1}}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-5 col-md-5 col-sm-12 mb-3">
                  <div class="form--item">
                    <div class="title">{{language.jobfamtitle6}}</div>
                    <div class="input">
                      <div class="input--container">
                        <input type="text" formControlName="c_occupation" class="form-control"
                          [ngClass]="{ 'is-invalid': Reqc_occupation }">
                      </div>
                      <div *ngIf="Reqc_occupation" class="error-message">
                        {{language.joberror1}}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-lg-6 col-md-6 col-sm-12 mb-3">
                  <div class="form--item">
                    <div class="title">{{language.jobfamtitle7}}</div>
                    <div class="input">
                      <div class="input--container">
                        <textarea class="p-5" type="text" formControlName="c_address" class="form-control"
                          [ngClass]="{ 'is-invalid': Reqc_address }"></textarea>
                      </div>
                      <div *ngIf="Reqc_address" class="error-message">
                        {{language.joberror1}}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
        </form>

        <!-- <div class="row" *ngIf="countChild != 3">
          <div class="col-lg-12 col-md-12 col-sm-12 mb-5">
            <app-button-job text="{{language.jobbtn1}}" (click)="addChild()">
              <button class="button--primary ml-auto mr-auto">
                <span>
                  <a>{{language.jobbtn1}}</a>
                </span>
              </button>
            </app-button-job>
          </div>
        </div> -->
        <!-- End บุตร -->
        <!-- อายุบุตร -->
        <!-- <form [formGroup]="formData">
          <div formArrayName="excisePersonInfo1"
            *ngFor="let creds of formData.get('excisePersonInfo1')['controls']; let i = index">
            <ng-container [formGroupName]="i">


              <div class="row" *ngIf="MaritalStatus != 'Single' && MaritalStatus != 'โสด'">
                <div class="col-lg-12 col-md-12 col-sm-12 mb-3 p-0 d-flex">
                  <div class="col-lg-3 col-md-3 col-sm-3 mb-3"></div>
                  <div class="col-lg-3 col-md-3 col-sm-3 mb-3" *ngIf="MaritalStatus == 'Married' || MaritalStatus == 'สมรส'"></div>
                  <div class="col-lg-3 col-md-3 col-sm-3 mb-3">
                    <div class="form--item" *ngIf="NumberChildren != 0">
                      <div class="title">{{language.jobapplydetail26}} {{i+1}}</div>
                      <div class="input">
                        <div class="input--container">
                          <input type="text" formControlName="age" id="age" class="form-control"
                            [ngClass]="{ 'is-invalid': Reqage1 }" maxlength="2" [pattern]="mobnumPattern" numbersOnly />
                        </div>
                        <div *ngIf="Reqage1" class="error-message">
                          {{language.joberror1}}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
        </form> -->

        <!-- สามี/ภรรยา -->
        <div *ngIf="MaritalStatus == 'Married' || MaritalStatus == 'สมรส'">
          <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 mb-3">
              <div class="form--item">
                <span rel="border-circle">
                  <i class="icon-fam"></i>
                </span>
                <div class="title pt-3 par-l">{{language.jobfamdetail5}}</div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-3 col-md-3 col-sm-12 mb-3">
              <div class="form--item">
                <div class="title">{{language.jobfamtitle1}}</div>
                <div class="form-group">
                  <div class="dropdown">
                    <button aria-expanded="false" aria-haspopup="true" class="select--button" data-toggle="dropdown"
                      id="dropdownMenu2" type="button" role="button">
                      <span>{{ s_title || defaultTitle || s_title }}</span>
                      <span>
                        <img src="assets/images/icon/caret-down@2x.png" alt="arrow-dropdown" />
                      </span>
                    </button>
                    <div aria-labelledby="dropdownMenu2" class="dropdown-menu" x-placement="bottom-start">
                      <ul aria-expanded="false" class="menu--list" role="listbox"
                        style="max-height: 450px; overflow-y: auto;">
                        <li *ngFor="let items of TitleTH" class="dropdown-item" style="height: 50px;" (change)="changeTitle($event.items)"
                          (click)="onclicks_title(items)">
                          <a aria-disabled="false" aria-selected="false" class="" data-tokens="null" role="option"
                            ta-tokens="null" tabindex="0" data-value="items">
                            <span class="text">{{items}}</span>
                            <span class="glyphicon glyphicon-ok check-mark"></span>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-12 mb-3">
              <div class="form--item">
                <div class="title">{{language.jobfamtitle10}}</div>
                <div class="input">
                  <div class="input--container">
                    <input (input)="s_fname=$event.target.value" type="text" name="s_fname" id="s_fname"
                      class="form-control" />
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-5 col-md-5 col-sm-12 mb-3">
              <div class="form--item">
                <div class="title">{{language.jobfamtitle11}}</div>
                <div class="input">
                  <div class="input--container">
                    <input (input)="s_lname=$event.target.value" type="text" name="s_lname" class="form-control" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-3 col-md-3 col-sm-12 mb-3">
              <div class="form--item">
                <div class="title">{{language.jobfamtitle4}}</div>
                <div class="input">
                  <div class="input--container">
                    <input (input)="s_age=$event.target.value" type="text" name="s_age" id="s_age" class="form-control"
                      numbersOnly minlength="2" />
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-12 mb-3">
              <div class="form--item">
                <div class="title">{{language.jobfamtitle5}}</div>
                <div class="input">
                  <div class="input--container">
                    <input (input)="s_tel=$event.target.value" type="text" name="s_tel" id="s_tel" class="form-control"
                      numbersOnly [maxLength]="10" />
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-5 col-md-5 col-sm-12 mb-3">
              <div class="form--item">
                <div class="title">{{language.jobfamtitle6}}</div>
                <div class="input">
                  <div class="input--container">
                    <input (input)="s_occupation=$event.target.value" type="text" name="s_occupation" id="s_occupation"
                      class="form-control" />
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12 mb-3">
              <div class="form--item">
                <div class="title">{{language.jobfamtitle7}}</div>
                <div class="input">
                  <div class="input--container">
                    <textarea class="p-5" (input)="s_address=$event.target.value" name="s_address"
                      maxlength="500"></textarea>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- End สามี/ภรรยา -->

        <header class="heading-contact mb-5 mt-5">
          <h2 class="topic-title">{{language.jobfamdetail1}}</h2>
          <p class="ingnor-top">* {{language.jobeduwarning2}} -</p>
        </header>

        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12 mb-3">
            <div class="form--item">
              <span rel="border-circle">
                <i class="icon-fam"></i>
              </span>
              <div class="title pt-3 par-l">{{language.jobfamdetail2}}</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-3 col-md-3 col-sm-12 mb-3">
            <div class="form--item">
              <div class="title">{{language.jobfamtitle1}}</div>
              <div class="form-group">
                <div class="dropdown">
                  <button aria-expanded="false" aria-haspopup="true" class="select--button" data-toggle="dropdown"
                    id="dropdownMenu2" type="button" role="button" [ngClass]="{ 'is-invalid': Reqf_title }">
                    <span>{{ f_title || defaultTitle || f_title }}</span>
                    <span>
                      <img src="assets/images/icon/caret-down@2x.png" alt="arrow-dropdown" />
                    </span>
                  </button>
                  <div aria-labelledby="dropdownMenu2" class="dropdown-menu" x-placement="bottom-start">
                    <ul aria-expanded="false" class="menu--list" role="listbox"
                      style="max-height: 450px; overflow-y: auto;">
                      <li *ngFor="let items of TitleTH" class="dropdown-item" style="height: 50px;" (change)="changeTitle($event.items)"
                        (click)="onclickTitle(items)">
                        <a aria-disabled="false" aria-selected="false" class="" data-tokens="null" role="option"
                          ta-tokens="null" tabindex="0" data-value="items">
                          <span class="text">{{items}}</span>
                          <span class="glyphicon glyphicon-ok check-mark"></span>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div *ngIf="Reqf_title" class="error-message">
                  {{language.joberror1}}
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-4 col-sm-12 mb-3">
            <div class="form--item">
              <div class="title">{{language.jobfamtitle10}}</div>
              <div class="input">
                <div class="input--container">
                  <input (input)="f_fname=$event.target.value" type="text" name="f_fname" id="f_fname"
                    class="form-control" [ngClass]="{ 'is-invalid': Reqf_fname }" />
                </div>
                <div *ngIf="Reqf_fname" class="error-message">
                  {{language.joberror1}}
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-5 col-md-5 col-sm-12 mb-3">
            <div class="form--item">
              <div class="title">{{language.jobfamtitle11}}</div>
              <div class="input">
                <div class="input--container">
                  <input (input)="f_lname=$event.target.value" type="text" name="f_lname" class="form-control"
                    [ngClass]="{ 'is-invalid': Reqf_lname }" />
                </div>
                <div *ngIf="Reqf_lname" class="error-message">
                  {{language.joberror1}}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-3 col-md-3 col-sm-12 mb-3">
            <div class="form--item">
              <div class="title">{{language.jobfamtitle4}}</div>
              <div class="input">
                <div class="input--container">
                  <input (input)="f_age=$event.target.value" type="text" name="f_age" id="f_age" class="form-control"
                    [ngClass]="{ 'is-invalid': Reqf_age }" numbersOnly minlength="2" />
                </div>
                <div *ngIf="Reqf_age" class="error-message">
                  {{language.joberror1}}
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-4 col-sm-12 mb-3">
            <div class="form--item">
              <div class="title">{{language.jobfamtitle5}}</div>
              <div class="input">
                <div class="input--container">
                  <input (input)="f_tel=$event.target.value" type="text" name="f_tel" id="f_tel" class="form-control"
                    [ngClass]="{ 'is-invalid': Reqf_tel }" numbersOnly [maxLength]="10" />
                </div>
                <div *ngIf="Reqf_tel" class="error-message">
                  {{language.joberror1}}
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-5 col-md-5 col-sm-12 mb-3">
            <div class="form--item">
              <div class="title">{{language.jobfamtitle6}}</div>
              <div class="input">
                <div class="input--container">
                  <input (input)="f_occupation=$event.target.value" type="text" name="f_occupation" id="f_occupation"
                    class="form-control" [ngClass]="{ 'is-invalid': Reqf_occupation }" />
                </div>
                <div *ngIf="Reqf_occupation" class="error-message">
                  {{language.joberror1}}
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-md-6 col-sm-12 mb-3">
            <div class="form--item">
              <div class="title">{{language.jobfamtitle7}}</div>
              <div class="input">
                <div class="input--container">
                  <textarea class="p-5" (input)="f_address=$event.target.value" name="f_address" maxlength="500"
                    [ngClass]="{ 'is-invalid': Reqf_address }"></textarea>
                </div>
                <div *ngIf="Reqf_address" class="error-message">
                  {{language.joberror1}}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12 mb-3 mt-5">
            <div class="form--item">
              <span rel="border-circle">
                <i class="icon-fam"></i>
              </span>
              <div class="title pt-3 par-l">{{language.jobfamdetail3}}</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-3 col-md-3 col-sm-12 mb-3">
            <div class="form--item">
              <div class="title">{{language.jobfamtitle1}}</div>
              <div class="form-group">
                <div class="dropdown">
                  <button aria-expanded="false" aria-haspopup="true" class="select--button" data-toggle="dropdown"
                    id="dropdownMenu2" type="button" role="button" [ngClass]="{ 'is-invalid': Reqm_title }">
                    <span>{{ m_title || defaultTitle }}</span>
                    <span>
                      <img src="assets/images/icon/caret-down@2x.png" alt="arrow-dropdown" />
                    </span>
                  </button>
                  <div aria-labelledby="dropdownMenu2" class="dropdown-menu" x-placement="bottom-start">
                    <ul aria-expanded="false" class="menu--list" role="listbox"
                      style="max-height: 450px; overflow-y: auto;">
                      <li *ngFor="let items of TitleTH" class="dropdown-item" style="height: 50px;" (change)="changeTitle($event.items)"
                        (click)="onclickm_title(items)">
                        <a aria-disabled="false" aria-selected="false" class="" data-tokens="null" role="option"
                          ta-tokens="null" tabindex="0" data-value="items">
                          <span class="text">{{items}}</span>
                          <span class="glyphicon glyphicon-ok check-mark"></span>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div *ngIf="Reqm_title" class="error-message">
                  {{language.joberror1}}
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-4 col-sm-12 mb-3">
            <div class="form--item">
              <div class="title">{{language.jobfamtitle10}}</div>
              <div class="input">
                <div class="input--container">
                  <input (input)="m_fname=$event.target.value" type="text" name="m_fname" id="m_fname"
                    class="form-control" [ngClass]="{ 'is-invalid': Reqm_fname }" />
                </div>
                <div *ngIf="Reqm_fname" class="error-message">
                  {{language.joberror1}}
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-5 col-md-5 col-sm-12 mb-3">
            <div class="form--item">
              <div class="title">{{language.jobfamtitle11}}</div>
              <div class="input">
                <div class="input--container">
                  <input (input)="m_lname=$event.target.value" type="text" name="m_lname" id="m_lname"
                    class="form-control" [ngClass]="{ 'is-invalid': Reqm_lname }" />
                </div>
                <div *ngIf="Reqm_lname" class="error-message">
                  {{language.joberror1}}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-3 col-md-3 col-sm-3 mb-3">
            <div class="form--item">
              <div class="title">{{language.jobfamtitle4}}</div>
              <div class="input">
                <div class="input--container">
                  <input (input)="m_age=$event.target.value" type="text" name="m_age" id="m_age" class="form-control"
                    [ngClass]="{ 'is-invalid': Reqm_age }" maxlength="2" numbersOnly />
                </div>
                <div *ngIf="Reqm_age" class="error-message">
                  {{language.joberror1}}
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-4 col-sm-12 mb-3">
            <div class="form--item">
              <div class="title">{{language.jobfamtitle5}}</div>
              <div class="input">
                <div class="input--container">
                  <input (input)="m_tel=$event.target.value" type="text" name="m_tel" id="m_tel" class="form-control"
                    [ngClass]="{ 'is-invalid': Reqm_tel }" numbersOnly [maxLength]="10" />
                </div>
                <div *ngIf="Reqm_tel" class="error-message">
                  {{language.joberror1}}
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-5 col-md-5 col-sm-12 mb-3">
            <div class="form--item">
              <div class="title">{{language.jobfamtitle6}}</div>
              <div class="input">
                <div class="input--container">
                  <input (input)="m_occupation=$event.target.value" type="text" name="m_occupation" id="m_occupation"
                    class="form-control" [ngClass]="{ 'is-invalid': Reqm_occupation }" />
                </div>
                <div *ngIf="Reqm_occupation" class="error-message">
                  {{language.joberror1}}
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-md-6 col-sm-12 mb-3">
            <div class="form--item">
              <div class="title">{{language.jobfamtitle7}}</div>
              <div class="input">
                <div class="input--container">
                  <textarea class="p-5" (input)="m_address=$event.target.value" name="m_address" maxlength="500"
                    [ngClass]="{ 'is-invalid': Reqm_address }"></textarea>
                </div>
                <div *ngIf="Reqm_address" class="error-message">
                  {{language.joberror1}}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12 mb-3 mt-5">
            <div class="form--item">
              <span rel="border-circle">
                <i class="icon-fam"></i>
              </span>
              <div class="title pt-3 par-l">{{language.jobfamdetail4}}</div>
            </div>
          </div>
        </div>

        <form [formGroup]="formDataSis">
          <div formArrayName="SisInfo" *ngFor="let DataSis of formDataSis.get('SisInfo')['controls']; let i = index">
            <ng-container [formGroupName]="i">

              <div class="row">
                <div class="col-lg-6 col-md-6 col-sm-6 mb-3 mt-5" *ngIf="i >=1">
                  <div class="title-group">{{language.jobnumber}} {{i+1}}</div>
                </div>

                <div class="col-lg-6 col-md-6 col-sm-6 mb-3 mt-5" *ngIf="i >=1">
                  <app-button-delete-job text="{{language.btn6}}" (click)="removeSister(i)">
                    <button class="button--primary">
                      <span>
                        <a routerLink="">{{language.jobbtn2}}</a>
                      </span>
                    </button>
                  </app-button-delete-job>
                </div>

                <div class="col-lg-3 col-md-3 col-sm-12 mb-3">
                  <div class="form--item">
                    <div class="title">{{language.jobfamtitle1}}</div>
                    <div class="form-group">
                      <div class="dropdown">
                        <select formControlName="b_title" class="form-control" [ngClass]="{ 'is-invalid': Reqb_title }">
                          <option *ngFor="let items of TitleTH" [value]="items" style=" border-radius: 50px;">
                            {{ items }}</option>
                        </select>
                      </div>
                      <div *ngIf="Reqb_title" class="error-message">
                        {{language.joberror1}}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-12 mb-3">
                  <div class="form--item">
                    <div class="title">{{language.jobfamtitle10}}</div>
                    <div class="input">
                      <div class="input--container">
                        <input type="text" formControlName="b_fname" class="form-control"
                          [ngClass]="{ 'is-invalid': Reqb_fname }">
                      </div>
                      <div *ngIf="Reqb_fname" class="error-message">
                        {{language.joberror1}}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-5 col-md-5 col-sm-12 mb-3">
                  <div class="form--item">
                    <div class="title">{{language.jobfamtitle11}}</div>
                    <div class="input">
                      <div class="input--container">
                        <input type="text" formControlName="b_lname" class="form-control"
                          [ngClass]="{ 'is-invalid': Reqb_lname }">
                      </div>
                      <div *ngIf="Reqb_lname" class="error-message">
                        {{language.joberror1}}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-lg-3 col-md-3 col-sm-12 mb-3">
                  <div class="form--item">
                    <div class="title">{{language.jobfamtitle4}}</div>
                    <div class="input">
                      <div class="input--container">
                        <input type="text" formControlName="b_age" class="form-control"
                          [ngClass]="{ 'is-invalid': Reqb_age }" maxlength="2" numbersOnly>
                      </div>
                      <div *ngIf="Reqb_age" class="error-message">
                        {{language.joberror1}}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-12 mb-3">
                  <div class="form--item">
                    <div class="title">{{language.jobfamtitle5}}</div>
                    <div class="input">
                      <div class="input--container">
                        <input type="text" formControlName="b_tel" class="form-control"
                          [ngClass]="{ 'is-invalid': Reqb_tel }" numbersOnly [maxLength]="10">
                      </div>
                      <div *ngIf="Reqb_tel" class="error-message">
                        {{language.joberror1}}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-5 col-md-5 col-sm-12 mb-3">
                  <div class="form--item">
                    <div class="title">{{language.jobfamtitle6}}</div>
                    <div class="input">
                      <div class="input--container">
                        <input type="text" formControlName="b_occupation" class="form-control"
                          [ngClass]="{ 'is-invalid': Reqb_occupation }">
                      </div>
                      <div *ngIf="Reqb_occupation" class="error-message">
                        {{language.joberror1}}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-lg-6 col-md-6 col-sm-12 mb-3">
                  <div class="form--item">
                    <div class="title">{{language.jobfamtitle7}}</div>
                    <div class="input">
                      <div class="input--container">
                        <textarea class="p-5" type="text" formControlName="b_address" class="form-control"
                          [ngClass]="{ 'is-invalid': Reqb_address }"></textarea>
                      </div>
                      <div *ngIf="Reqb_address" class="error-message">
                        {{language.joberror1}}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
        </form>

        <div class="row" *ngIf="countSister != 3">
          <div class="col-lg-12 col-md-12 col-sm-12 mb-5">
            <app-button-job text="{{language.jobbtn1}}" (click)="addSister()">
              <button class="button--primary ml-auto mr-auto">
                <span>
                  <a>{{language.jobbtn1}}</a>
                </span>
              </button>
            </app-button-job>
          </div>
        </div>

        <header class="heading-contact mb-5 mt-5">
          <h2 class="topic-title">{{language.jobfamdetail10}}
          </h2>
        </header>

        <div class="row urgent-contact">
          <div class="col-lg-3 col-md-3 col-sm-12 mb-3">
            <div class="form--item">
              <div class="title d-flex">{{language.jobfamtitle1}}<p class="req pl-3">*</p>
              </div>
              <div class="form-group">
                <div class="dropdown">
                  <button aria-expanded="false" aria-haspopup="true" class="select--button" data-toggle="dropdown"
                    id="dropdownMenu2" type="button" role="button" [ngClass]="{ 'is-invalid': Requrgent_title }">
                    <span>{{ urgent_title || defaultTitle }}</span>
                    <span>
                      <img src="assets/images/icon/caret-down@2x.png" alt="arrow-dropdown" />
                    </span>
                  </button>
                  <div aria-labelledby="dropdownMenu2" class="dropdown-menu" x-placement="bottom-start">
                    <ul aria-expanded="false" class="menu--list" role="listbox"
                      style="max-height: 450px; overflow-y: auto;">
                      <li *ngFor="let items of TitleTH" class="dropdown-item" style="height: 50px;" (change)="changeTitle($event.items)"
                        (click)="onclickurgent_title(items)">
                        <a aria-disabled="false" aria-selected="false" class="" data-tokens="null" role="option"
                          ta-tokens="null" tabindex="0" data-value="items">
                          <span class="text">{{items}}</span>
                          <span class="glyphicon glyphicon-ok check-mark"></span>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div *ngIf="Requrgent_title" class="error-message">
                  {{language.joberror1}}
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-4 col-sm-12 mb-3">
            <div class="form--item">
              <div class="title d-flex">{{language.jobfamtitle10}}<p class="req pl-3">*</p>
              </div>
              <div class="input">
                <div class="input--container">
                  <input (input)="urgent_fname=$event.target.value" type="text" name="urgent_fname" id="urgent_fname"
                    class="form-control" [maxLength]="20" [ngClass]="{ 'is-invalid': Requrgent_fname }" />
                </div>
                <div *ngIf="Requrgent_fname" class="error-message">
                  {{language.joberror1}}
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-5 col-md-5 col-sm-12 mb-3">
            <div class="form--item">
              <div class="title d-flex">{{language.jobfamtitle11}}<p class="req pl-3">*</p>
              </div>
              <div class="input">
                <div class="input--container">
                  <input (input)="urgent_lname=$event.target.value" type="text" name="urgent_lname" id="urgent_lname"
                    class="form-control" [maxLength]="20" [ngClass]="{ 'is-invalid': Requrgent_lname }" />
                </div>
                <div *ngIf="Requrgent_lname" class="error-message">
                  {{language.joberror1}}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row urgent-contact">
          <div class="col-lg-4 col-md-4 col-sm-4 mb-3">
            <div class="form--item">
              <div class="title d-flex">{{language.jobfamtitle8}}<p class="req pl-3">*</p>
              </div>
              <div class="input">
                <div class="input--container">
                  <input (input)="urgent_relation=$event.target.value" type="text" name="urgent_relation"
                    id="urgent_relation" class="form-control" [maxLength]="20"
                    [ngClass]="{ 'is-invalid': Requrgent_relation }" />
                </div>
                <div *ngIf="Requrgent_relation" class="error-message">
                  {{language.joberror1}}
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-4 col-sm-4 mb-3">
            <div class="form--item">
              <div class="title d-flex">{{language.jobfamtitle9}}<p class="req pl-3">*</p>
              </div>
              <div class="input">
                <div class="input--container">
                  <input (input)="urgent_tel=$event.target.value" type="text" name="urgent_tel" id="urgent_tel"
                    class="form-control" [maxLength]="10" [ngClass]="{ 'is-invalid': Requrgent_tel }" numbersOnly />
                </div>
                <div *ngIf="Requrgent_tel" class="error-message">
                  {{language.joberror1}}
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-4 col-sm-4 mb-3">
            <div class="form--item">
              <div class="title d-flex">{{language.jobfamtitle7}}<p class="req pl-3">*</p>
              </div>
              <div class="input">
                <div class="input--container">
                  <textarea class="p-5" (input)="urgent_address=$event.target.value" name="urgent_address" id="urgent_address"
                    [maxLength]="200" [ngClass]="{ 'is-invalid': Requrgent_address }"></textarea>
                </div>
                <div *ngIf="Requrgent_address" class="error-message">
                  {{language.joberror1}}
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- ถัดไป -->
        <div class="row">
          <div class="col-lg-6 col-md-6 col-sm-6 mt-5">
            <app-button text="{{language.jobbtn6}}" (click)="goEducation()">
              <button class="button--primary ml-auto mr-auto">
                <span>
                  <a>{{language.jobbtn6}}</a>
                </span>
              </button>
            </app-button>
          </div>
          <div class="col-lg-6 col-md-6 col-sm-6 mt-5">
            <app-button text="{{language.jobbtn5}}" (click)="goExperience()">
              <button class="button--primary ml-auto mr-auto">
                <span>
                  <a>{{language.jobbtn5}}</a>
                </span>
              </button>
            </app-button>
          </div>
        </div>
        <!-- ถัดไป -->
      </div>
    </div>
  </div>
  <!-- ข้อมูลครอบครัว -->
</div>